var __importDefault = (this && this.__importDefault) || function (mod) {
  return (mod && mod.__esModule) ? mod : { "default": mod };
};
import * as React from 'react';
import { Icon } from '@fluentui/react';
import { ENDORSEMENT_LEGEND } from '../shared/fmEndorsement';
/**
 * Profile-completeness endorsement legend (F2) — React port of the PROFILE COMPLETENESS
 * dropdown in `fmforecastview.html` (lines 16-20): the five endorsement states, each with a
 * status icon and label. Sourced from `ENDORSEMENT_LEGEND` so it stays a single source of truth.
 */
export const EndorsementLegend = () => (React.createElement("ul", { "data-testid": "endorsement-legend", role: "menu", "aria-label": "Profile completeness endorsement legend", style: { listStyle: 'none', margin: 0, padding: 8, minWidth: 260 } }, ENDORSEMENT_LEGEND.map((e) => (React.createElement("li", { key: e.key, role: "menuitem", style: { display: 'flex', alignItems: 'center', padding: '3px 8px', fontSize: 13 } },
    React.createElement(Icon, { iconName: e.iconName, "aria-hidden": "true", styles: { root: { fontSize: 16, marginRight: 8, color: e.color, flex: '0 0 auto' } } }),
    React.createElement("span", null, e.label))))));
export default EndorsementLegend;
//# sourceMappingURL=EndorsementLegend.js.map